import { render, staticRenderFns } from "./CookiePopup.vue?vue&type=template&id=3b5df0a6&scoped=true&"
import script from "./CookiePopup.vue?vue&type=script&lang=js&"
export * from "./CookiePopup.vue?vue&type=script&lang=js&"
import style0 from "./CookiePopup.vue?vue&type=style&index=0&id=3b5df0a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5df0a6",
  null
  
)

export default component.exports